import { render, staticRenderFns } from "./side-msg.vue?vue&type=template&id=a59fac30"
import script from "./side-msg.vue?vue&type=script&lang=js"
export * from "./side-msg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports